import React, { useEffect } from "react";

import CommunityJoiningPage from "@/containers/CommunityJoiningPages/CommunityJoiningPage";

import { appendHotJarScript, renderMetaData } from "@/utils";

const CommunityJoining = () => {
  // FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/joincommunity",
    title:
      "Join Health Focused Communities by Shyft | Curated into different groups to bring like minded people together",
    description:
      "Join health communities with like-minded people that motivate, inspire and help achieve health goals. Members are screened and allocated a group based on their interests and purpose",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-05/community-by-shyft-ce1466c55afc46dea1ac4e9641aa00bd.jpg",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <CommunityJoiningPage />
    </>
  );
};

export default CommunityJoining;
